import { FarmData } from "../interfaces/FarmData";
import { AxiosInstance, AxiosResponse } from 'axios';
import HttpClient from "./httpClient";

class FarmService {

  private baseUrl = process.env.REACT_APP_API_BASE_URL as string
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = new HttpClient(this.baseUrl).getAxiosInstance();
  }



  async getFarmById(id: number): Promise<FarmData> {
    try {
      const endpoint = `/farms/${id}`;
      const response: AxiosResponse<FarmData> = await this.axiosInstance.get(endpoint);
      console.debug("Farm retrieved successfully:", response.data);
      return response.data;
    } catch (error: any) {
      console.error("Error retrieving farm:", error.response?.data || error.message);
      throw error;
    }
  }

  async getFarms(): Promise<FarmData[]> {
    try {
      const endpoint = `/farms`;
      const response: AxiosResponse = await this.axiosInstance.get(endpoint);
      console.debug("Parcels fetched successfully:", response.data);
      return response.data.data;
    } catch (error: any) {
      console.error("Error fetching parcels by farm ID:", error.response?.data || error.message);
      throw error;
    }
  }


  async createFarm(farm: FarmData): Promise<FarmData> {
    try {
      const endpoint = "/farms";
      const response: AxiosResponse = await this.axiosInstance.post(endpoint, farm);
      console.debug("Farm created successfully:", response.data);
      return response.data;
    } catch (error: any) {
      console.error("Error creating farm:", error.response?.data || error.message);
      throw error;
    }
  }

  async updateFarm(id: number , farm: FarmData): Promise<FarmData> {
    try {
      const endpoint = `/farms/${id}`;
      const response: AxiosResponse = await this.axiosInstance.patch(endpoint, farm);
      console.debug("Farm updated successfully:", response.data);
      return response.data;
    } catch (error: any) {
      console.error("Error updating farm:", error.response?.data || error.message);
      throw error;
    }
  }
}

export default FarmService;